import { Paper, Typography } from '@mui/material'
import { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../app/store'
import ResponsiveAppBar from '../ResponsiveAppBar'
import { useGetMemberInfoQuery, useGetUserInfoQuery } from '../services/api'
import { StyledHeaderBox } from '../StyledHeaderBox'

type VerificationResponse = {
  currentStep?: 'collectFirstResponderPersonalInfo' | 'docUpload' | 'error' | 'pending' | 'success'
  verificationId: string
}

const IdVerify = () => {
  const { data: user, refetch: refetchUserInfo } = useGetUserInfoQuery()
  const { data: member, refetch: refetchMemberInfo } = useGetMemberInfoQuery()
  const accessToken = useSelector((state: RootState) => state.auth.accessToken)

  const disposeHooks = useCallback(() => {
    const hooks = (window as any).sheerId.myHooks
    console.debug('hooks', hooks)
    if (!hooks) return

    for (let i = 0; i < hooks.ON_VERIFICATION_STEP_CHANGE?.length; i++) {
      delete hooks?.ON_VERIFICATION_STEP_CHANGE[0];
    }
    for (let i = 0; i < hooks.ON_VERIFICATION_SUCCESS?.length; i++) {
      delete hooks?.ON_VERIFICATION_SUCCESS[0];
    }
  }, [])

  const onPreverify = useCallback((verificationId: string) => {
    window.fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/id/preverify/${verificationId}`, {
      headers: {
        authorization: `Bearer ${accessToken}`
      },
      method: 'POST',
    })
      .then(res => res.json())
      .then(json => {
        if (json?.verificationId && json.verificationId !== verificationId) {
          window.location.href = `/verify?verificationId=${json.verificationId}`;
        }
      })
  }, [accessToken])

  const onSuccess = useCallback((verificationId: string) => {
    window.fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/id/verify/${verificationId}`, {
      headers: {
        authorization: `Bearer ${accessToken}`
      },
      method: 'POST',
    })
      .then(res => {
        return res.json()
      })
      .then(json => {
        console.debug('verification details', json)
        refetchUserInfo()
        refetchMemberInfo()
      })
  }, [accessToken, refetchMemberInfo, refetchUserInfo])

  useEffect(() => {
    const sheerId = (window as any).sheerId
    console.debug('effect', sheerId.hooks)
    if (member) {
      console.debug('member', member)
      sheerId.addHook({
        callback: (response: VerificationResponse) => {
          console.debug('ON_VERIFICATION_STEP_CHANGE', response)
          if (response.currentStep === 'collectFirstResponderPersonalInfo') {
            onPreverify(response.verificationId)
          }
          else if (response.currentStep === 'success') {
            onSuccess(response.verificationId)
          }
        },
        name: 'ON_VERIFICATION_STEP_CHANGE'
      })
      sheerId.myHooks = sheerId.addHook({
        callback: (response: VerificationResponse) => {
          console.debug('ON_VERIFICATION_SUCCESS', response)
          onSuccess(response.verificationId)
        },
        name: 'ON_VERIFICATION_SUCCESS'
      })
      setTimeout(() => {
        const myProgramId = process.env.REACT_APP_SHEERID_PROGRAM_ID || '';
        console.debug('myProgramId', myProgramId, member.type)
        if (myProgramId) {
          const myDiv = document.getElementById('id-verify-form');
          const form = new sheerId.VerificationForm(myDiv, myProgramId);
          console.debug('form', form, sheerId.myHooks)
        }
      }, 500)
    }

    return disposeHooks

  }, [disposeHooks, onPreverify, onSuccess, member])

  if (!user)
    return null;

  return (
    <>
      <ResponsiveAppBar />
      <Paper
        style={{
          background: '#a0b1af',
          height: 'calc(100vh - 56px)',
          overflow: 'scroll',
          paddingBottom: 10,
          paddingTop: 10,
        }}
      >
        <StyledHeaderBox>
          <Typography
            sx={{
              marginLeft: { xs: 1 }
            }}
            variant="h6"
          >ID Verification</Typography>
        </StyledHeaderBox>
        <div id='id-verify-form' />
      </Paper>
    </>
  )
}

export default IdVerify;